import { Button } from '@systemeio/components'
import React from 'react'
import { FormInput, FormTextarea, Modal } from 'shared/components'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { copyTextToClipboard } from 'shared/utils/copy-text-to-clipboard'

export interface LinkShareModalProps {
  opened: boolean
  link: string | undefined
  title: string
  label: string
  onClose: () => void
  onOpen?: () => void
  showInTextArea?: boolean
  isLoading?: boolean
}

const LinkShareModal = ({
  link,
  opened,
  onClose,
  title,
  label,
  onOpen,
  showInTextArea = false,
  isLoading,
}: LinkShareModalProps) => {
  const { t } = useLocoTranslation()

  return (
    <Modal afterEnter={onOpen} opened={opened} onClose={onClose} title={title}>
      <form className="desktop:gap-10 flex flex-col gap-6">
        <div className="flex flex-col justify-center gap-3">
          {showInTextArea ? (
            <FormTextarea label={label} value={link} disabled isPreFetching={isLoading} />
          ) : (
            <FormInput label={label} value={link} disabled isPreFetching={isLoading} />
          )}
        </div>
        <div className="tablet:[&>*]:flex-none tablet:[&>*]:w-auto flex justify-end gap-3 [&>*]:flex-1">
          <Button
            disabled={isLoading}
            onClick={async (e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault()
              if (!link) return

              await copyTextToClipboard(link)
              onClose()
            }}
            variant="primary"
            size="md"
          >
            {t('global.copy_to_clipboard_caption')}
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default LinkShareModal
